import { z } from 'zod';
import { AuditSchema } from './audit.schema';
import {
  EntityEventChangeSchema
} from './event-change.schema';

export * from './audit.schema';
export * from './base.schema';
export * from './event-change.schema';
export * from './settings-field.schema';
export * from './settings-section.schema';

/**
 * Image reference schema.
 */
export const ImageRefSchema = z.object({
  url: z.string().url(),
  path: z.string(),
});

/**
 * Processed image variants.
 */
export const ProcessedImageSchema = z.object({
  id: z.string().uuid(),
  original: ImageRefSchema,
  profile: ImageRefSchema,
  miniature: ImageRefSchema,
});

export const GraphPositionSchema = z.object({
  x: z.number(),
  y: z.number(),
});

/**
 * Base Entity schema.
 */
export const EntitySchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Name is required'),
  shortDescription: z.string().default(''),
  description: z.string().optional(),
  images: z.array(ProcessedImageSchema).default([]),
  primaryImageId: z.string().uuid().nullable(),
  mainImageUrl: z.string().optional(),
  mainImagePath: z.string().optional(),
  graphPosition: GraphPositionSchema.optional(),
  graphPositionUpdatedBy: z.string().optional(),
  graphPositionUpdatedAt: z.string().optional(),
  visualDescription: z.string().optional().describe('Text description of the entity for AI image generation'),
  details: z.record(z.unknown()).optional(),
  eventChanges: z.array(EntityEventChangeSchema).optional(),
  audit: AuditSchema,
  isArchived: z.boolean().optional(),
});

export type Entity = z.infer<typeof EntitySchema>;
export type ImageRef = z.infer<typeof ImageRefSchema>;
export type ProcessedImage = z.infer<typeof ProcessedImageSchema>;
